import type { OrderDialogState } from "@talentir/shared/common-types";
import { useAtom } from "jotai";
import { atomWithHash } from "jotai-location";

const buySellDialogAtom = atomWithHash<undefined | OrderDialogState>("buySellDialog", undefined);
const claimDialogAtom = atomWithHash<{ type: "youtube" | "campaign"; id: string }[] | undefined>(
    "claimDialog",
    undefined,
);

export function useBuySellDialog() {
    return useAtom(buySellDialogAtom);
}

export function useClaimDialog() {
    return useAtom(claimDialogAtom);
}
